import { render, staticRenderFns } from "./MonthlySales.vue?vue&type=template&id=922e4e10&"
import script from "./MonthlySales.vue?vue&type=script&lang=js&"
export * from "./MonthlySales.vue?vue&type=script&lang=js&"
import style0 from "./MonthlySales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports